import { gql } from '@apollo/client';

export const GET_ORG = gql`
  query getOrg($orgId: Int!) {
    org: getOrg(orgId: $orgId) {
      orgId
      name
      description
      disclaimer
      schoolApproved
      links {
        call
        website
        email
      }
      tags
      locations
      address
      mapUrl
      yearEstablished
      childEnrichmentStatement
      socialMediaUrl
      seasonality
      referralSource
      currentProgram {
        flyerId
        title
        frontImageUrl
        distributionsReleased
      }
      previouslyPosted {
        flyerId
        title
        frontImageUrl
        distributionsReleased
      }
    }
  }
`;
